module.exports = __webpack_public_path__ + "img/scene_12.b082b11a.jpg";